import _ from 'lodash';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const getSettings = createSelector(getSystem, ({ settings }) => settings);

const getSettingsValues = createSelector(getSettings, settings => Object.values(settings));

const getFilteredSettingsValues = createSelector(
  getDebouncedSearchValue,
  getSettingsValues,
  searchItems(({ key, value }) => [key, value || '']),
);

export const getSortedByKeySettingsValues = createSelector(getFilteredSettingsValues, settings =>
  _.sortBy(settings, ({ key }) => key.toLowerCase()),
);
